import { apiClient } from '@/lib/api-client';
import { API_CONFIG } from '@/config/api';

/**
 * Razorpay payment data interface
 */
export interface RazorpayPaymentData {
  key: string;
  amount: number;
  name: string;
  description: string;
  image: string;
  prefill: {
    name: string;
    email: string | null;
    contact: string;
  };
  notes: {
    address: string | null;
    merchant_order_id: number;
  };
  theme: {
    color: string;
  };
  order_id: string;
}

/**
 * Payment info response interface
 */
export interface PaymentInfoResponse {
  status: boolean;
  proceedPayment: boolean;
  data: RazorpayPaymentData;
  json: string;
}

/**
 * Payment request body interface
 */
export interface PaymentInfoRequest {
  shipping_address: number;
  billing_address: number;
  payment_mode: string;
  cart_id: number;
}

/**
 * Initiate payment and get Razorpay configuration
 */
export const initiatePayment = async (
  paymentData: PaymentInfoRequest
): Promise<PaymentInfoResponse> => {
  try {
    const response = await apiClient.post<PaymentInfoResponse>(
      `${API_CONFIG.ENDPOINTS.PAYMENT}?token=true`,
      paymentData
    );
    return response;
  } catch (error) {
    console.error('Payment initiation error:', error);
    throw error;
  }
};
